import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import Modal, { ModalActions, ModalContent, ModalHeader, ModalTitle } from "../components/Modal";
import { Button } from "../components/Button";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash";
import { selectCurrentProjectId } from '../store/models/Project';
import Ai from '../store/models/Ai';

export const ScaleGpuClusterModal = ({ onRequestClose, suffix, fetchData }) => {
  const dispatch = useDispatch();
  const projectId = useSelector(state => selectCurrentProjectId(state));
  const {
    register,
    handleSubmit,
    formState
  } = useForm();
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (formState.errors.addNodes) {
      setError('Please enter a valid number')
    }
  }, [formState]);

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(scaleCluster)();
  }

  const scaleCluster = async (body) => {
    setLoading(true);
    setError(null);
    try {
      await dispatch(Ai.actions.scaleGpuCluster(projectId, suffix, body));
      await fetchData();
      onRequestClose();
    } catch (e) {
      setLoading(false);
      setError(e.message)
    }
  }

  return (
    <Modal className={cx("ScaleGpuClusterModal")}
      onRequestClose={onRequestClose}>

      <ModalHeader>
        <ModalTitle>Scale GPU Cluster</ModalTitle>
      </ModalHeader>

      <ModalContent>
        <form onSubmit={onSubmit} className={"NewForm"}>
          <div className={"NewForm__Row NewForm__Row--last"}>
            <div className={"NewForm__InputTextWrapper"}>
              <div className={"NewForm__InputLabel"}>Number of new nodes to be added</div>
              <input name="addNodes"
                type={"number"}
                step={1}
                placeholder={"Enter the number of new nodes to be added"}
                defaultValue={1}
                {...register("add_nodes", {
                  required: true,
                  valueAsNumber: true,
                  validate: (value) => Number.isInteger(value) || "Must be an integer",
                })} />
            </div>
          </div>
          <div className={cx("NewFormError")}>{error && error}</div>
          <ModalActions>
            <Button color={"green"} role={'submit'} loading={loading} title={"Add Nodes"} />
            <Button color={"transparent"} onClick={onRequestClose} title={"Cancel"} />
          </ModalActions>
        </form>
      </ModalContent>

    </Modal>
  );
}